import { useCallback } from 'react';
import { usePlayerContext } from '../PlayerContext';
import { useStore } from '../hooks/useStore';
import styles from './AccessDenied.module.css';

export function AccessDenied() {
  const { store } = usePlayerContext();
  const accessDenied = useStore(store, useCallback(s => s.accessDenied, []));

  return (
    <div className={`${styles.overlay}${accessDenied ? ` ${styles.visible}` : ''}`}>
      <svg className={styles.icon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1a5 5 0 0 0-5 5v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2h-1V6a5 5 0 0 0-5-5zm3 7H9V6a3 3 0 1 1 6 0v2zm-3 5a2 2 0 0 1 1 3.73V18a1 1 0 1 1-2 0v-1.27A2 2 0 0 1 12 13z" />
      </svg>
      <p className={styles.title}>Доступ запрещён</p>
      <p className={styles.message}>Нет доступа к трансляции</p>
    </div>
  );
}
